import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { AppContext, LobbyBannerContext, UserContext } from 'commons-ui';

import { APP_LANGUAGE } from 'commons/models/common';
import { IUpdateKeyResponse } from 'pages/admin/zooKeeper/utils/zk.interface';
import useService from '../../utils/useService';
import { getBannerFormDefaults } from '../../utils/formConfig';
import { dehydrateFormData } from '../../utils/formDataParser';
import { ITournamentBanner, TTournamentBannerConfig } from '../../utils/constants';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const { user } = useContext(UserContext);

	const history = useHistory();
	const { requestCreateLobbyBanner, handleCreateConfigBasedLobbyBanner } = useService();
	const { lobbyBannerData: lobbyBannerRows } = useContext(LobbyBannerContext);

	const createLobbyBanner = (createdData: ITournamentBanner, language: APP_LANGUAGE) => {
		setShowLoader(true);
		const lobbyBannerDataConfig: TTournamentBannerConfig = handleCreateConfigBasedLobbyBanner(
			createdData,
			lobbyBannerRows.data,
			language
		);

		requestCreateLobbyBanner(app.appName, user, lobbyBannerRows.gameName, lobbyBannerDataConfig).then(
			(res: IUpdateKeyResponse) => {
				if (!res?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the lobby banner', { type: 'error' });
					setShowLoader(false);
					return;
				}

				showAlert('Banner created');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		const { language } = submittedData;
		createLobbyBanner(dehydrateFormData(submittedData), language);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: getBannerFormDefaults(), showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
